import React from "react"

import classNames from "classnames"
import createReactClass from "create-react-class"
import PropTypes from "prop-types"

import styles from "./style.less"

export const Spinner = createReactClass({
  propTypes: {
    className: PropTypes.string,
  },
  getClass() {
    return classNames(styles.spinner, this.props.className)
  },
  render() {
    return (
      <div className={this.getClass()}>
        <div />
        <div />
        <div />
      </div>
    )
  },
})

export default Spinner
